import React from "react";
import PropTypes from "prop-types";

import "./Stepper.scss";

/**
 * Segmented progress bar + “Step 01 of 03” label.
 * `currentStep` is 1-based (first step = 1).
 */
const Stepper = ({ currentStep, totalSteps, label, className }) => {
  const safeTotal = Math.max(1, totalSteps);
  const safeCurrent = Math.min(Math.max(1, currentStep), safeTotal);

  return (
    <div
      className={`auth-stepper ${className || ""}`}
      role="group"
      aria-label={label}
    >
      <p className="auth-stepper__label mb-2">{label}</p>
      <div
        className="auth-stepper__track"
        role="progressbar"
        aria-valuenow={safeCurrent}
        aria-valuemin={1}
        aria-valuemax={safeTotal}
        aria-label={label}
      >
        {Array.from({ length: safeTotal }, (_, index) => {
          let segmentState = "is-upcoming";
          if (index < safeCurrent - 1) segmentState = "is-completed";
          else if (index === safeCurrent - 1) segmentState = "is-current";
          return (
            <div
              key={index}
              className={`auth-stepper__segment ${segmentState}`}
            />
          );
        })}
      </div>
    </div>
  );
};

Stepper.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Stepper.defaultProps = {
  className: "",
};

export default Stepper;
